export default "__VITE_ASSET__d6f133c7__"